import styled from 'styled-components'

export default styled.p`
    ${props => props.center ? 'text-align: center;' : ''}
    ${props => props.margin ? `margin: ${props.margin}px 0` : ''};
    &:last-child {
        margin-bottom: 0;
    }
`



// WEBPACK FOOTER //
// ./src/primitives/P.js